module.exports = __webpack_public_path__ + "media/images/no-resume-18674265871dfacc5a39e5defed0b744.svg";